import { AxiosInstance } from "axios";

class BaseUseCase {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  getConfigHeaders() {
    const jwtToken = sessionStorage.getItem("jwtToken");
    const userId = parseInt(sessionStorage.getItem("userId"));
    const config = {
      headers: { "user-id": userId, Authorization: `Bearer ${jwtToken}` },
    };

    return config;
  }
}

export default BaseUseCase;
